export default __webpack_public_path__ + "static/media/logo.b67a4209.svg";